import React from 'react';
import EmptyIcon from '../svgs/EmptyIcon';

const Panel = props => {
  const { isEmpty, emptyContent, title, headerShadow = true, children } = props;

  return (
    <div className="panel__wrapper">
      <div className={`panel__header ${headerShadow ? 'panel__header--shadow' : ''}`}>
        <h2 className="panel__header-title">{title}</h2>
      </div>
      <div className={`panel__content ${headerShadow ? '' : 'panel__content--no-padding-top'}`}>
        {isEmpty ? (
          <div className="panel__content--empty">
            <div className="panel__content-empty-icon">
              <EmptyIcon />
            </div>
            <div className="panel__content--empty-text">{emptyContent}</div>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
};

export default Panel;
